import React from 'react';
import { Link } from 'react-router-dom';

import './izvestajitemmein.styles.css';


const IzvestajItemMein = props =>{   
    return(          
     
        <ul className="row"> 
            <div className="story">
                <figure className="story__shape">
                <img src={props.image} alt={props.naslov} className="story__img" />
                    {/* <img src="img/nat-8.jpg" alt="Person on a tour" className="story__img" /> */}
                    <figcaption className="story__caption">{ (new Date(props.datum)).toLocaleDateString('en-GB') }</figcaption>
                </figure>
                <div className="story__text">
                    <h3 className="heading-tertiary u-margin-bottom-small">{props.naslov}</h3>
                    <p>
                        {props.opis.substring(0, 240) + '...'}
                    </p>
                </div>
                <Link to={`izvestaji/${props.id}`} className="btn-text btn-meinizvestaj">Pročitaj više &rarr;</Link>
            </div>     
            </ul>


      
    )

}

export default IzvestajItemMein